import { Box, Stack, Text } from '@chakra-ui/react';
import { CheckCircleSolid } from 'iconoir-react';
import { useTranslation } from 'react-i18next';

/** Shown in place of the steps once the new connection reaches Fluenceur. */
export const AssistantConnectSuccess: React.FC<{ name: string }> = ({ name }) => {
  const { t } = useTranslation();

  return (
    <Stack align="center" textAlign="center" gap={2} py={4}>
      <Box color="green.500" aria-hidden="true">
        <CheckCircleSolid width={40} height={40} />
      </Box>
      <Text fontWeight="semibold" fontSize="md">
        {t('integrations.assistants.dialog.successTitle', { name })}
      </Text>
      <Text fontSize="sm" color="fg.muted">
        {t('integrations.assistants.dialog.successBody')}
      </Text>
    </Stack>
  );
};
